import * as React from "react";

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#45A92C"
        d="M4.197 2.519a1.68 1.68 0 1 1 0 3.358 1.68 1.68 0 0 1 0-3.358ZM7.136 0H1.678C0 0 0 0 0 1.68v5.457c0 1.26.034 1.209.638 1.813l10.596 10.597c.605.604.588.604 1.193 0l7.136-7.104c.588-.587.588-.621-.016-1.209L8.933.638C8.328.05 8.395 0 7.136 0Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
